import moment from 'moment';
import 'moment/locale/ru';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LangProvider: FC<PropsWithChildren> = ({ children }) => {
  const { i18n } = useTranslation();
  useEffect(() => {
    moment.locale(i18n.language);
    document.documentElement.lang = i18n.resolvedLanguage ?? i18n.language;
  }, [i18n.language]);

  return <>{children}</>;
};

export default LangProvider;
